<template>
  <div>

    <v-simple-table class="table-layout pa-5 border-table">
      <template v-slot:default>
        <thead>
          <tr>
            <th>STT</th>
            <th>Ngày thanh toán</th>
            <th>Hoa hồng</th>
            <th>Thưởng</th>
            <th>Thuế thu nhập</th>
            <th>Thực nhận</th>
            <th>Người thực hiện</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in dataTransactions">
            <tr
              :key="item.id"
            >
              <td>{{ limit*(currentPage-1) + index + 1 }}</td>
              <td>{{ _.get(item, 'pay_date') }}</td>
              <td>{{ _.get(item, 'rose') }}
              <td>{{ _.get(item, 'bonus') }}</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
  export default {
    components: {},
    props: {
      currentPage: {
        type: Number,
        default: () => 1,
      },
      limit: {
        type: Number,
        default: () => 10,
      },
      dataTransactions: {
        type: Array,
        default: () => [],
      }
    },
    data () {
      return {
        modalAlert: false,
        errorMessage: '',
      }
    },
    created () {
    },
    methods: {
    },
  }
</script>
<style scoped>
.table-layout tr th {
  background-color: #e91e63;
  color: white !important;
}
</style>